import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import UsersForm from './form';
export default function UsersCreate() {

    return (
        <div>
            <MyBreadcrumb items={[{ label: "Users", path: "/users" }, { label: "Create", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Create"
                subTitle=""
            >
                <UsersForm />
            </PageHeader>
        </div>
    );
}